import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "tabButton"]
  static values = { modelKey: String }

  connect() {
    // Pole z `required` schowane w zwiniętej sekcji cicho blokuje submit — przeglądarka nie
    // umie pokazać komunikatu na niewidocznym polu ("not focusable" w konsoli), więc user
    // klika "Zapisz" i nic się nie dzieje. Nasłuchujemy `invalid` w fazie capture (zdarzenie
    // nie bąbelkuje), rozwijamy sekcję i pokazujemy komunikat na polu.
    this.form = this.element.closest("form")
    if (this.form) this.form.addEventListener("invalid", this.revealInvalidField, true)
  }

  disconnect() {
    if (this.form) this.form.removeEventListener("invalid", this.revealInvalidField, true)
  }

  // Handler jako property (nie metoda), żeby `this` wskazywało kontroler i żeby
  // removeEventListener dostał tę samą referencję.
  revealInvalidField = event => {
    if (this.reportingValidity) return

    const field = event.target
    if (!this.isHiddenInMoreOptions(field)) return

    this.showTab("more_options")
    // Sekcja jest już widoczna, ale przeglądarka zdążyła uznać pole za niefokusowalne —
    // ponawiamy komunikat po przeliczeniu layoutu. Flaga chroni przed pętlą, bo
    // reportValidity() ponownie odpala `invalid`.
    this.reportingValidity = true
    requestAnimationFrame(() => {
      field.focus()
      field.reportValidity()
      this.reportingValidity = false
    })
  }

  // Czy pole leży w zwiniętej sekcji "Dodatkowe opcje" tego kontrolera.
  // `offsetParent === null` to sprawdzenie widoczności (element nie jest renderowany).
  isHiddenInMoreOptions(field) {
    const moreOptions = this.tabTargets.find(tab => tab.id === "more_options")
    if (!moreOptions || !moreOptions.contains(field)) return false

    return field.offsetParent == null
  }

  toggleMoreOptions(event) {
    this.showTab(event.params.id)

    // Zapisz preferencję w ustawieniach użytkownika
    if (this.hasModelKeyValue && this.modelKeyValue) {
      const isOpen = event.params.id === "more_options"
      this.savePreference(isOpen)
    }
  }

  // Pokazuje wskazaną zakładkę (more_options/less_options) i chowa pozostałe.
  // Bez zapisu preferencji — używane też przy auto-rozwinięciu z walidacji.
  showTab(id) {
    this.tabTargets.forEach(card => {
      if (card.id === id) {
        card.classList.remove("hidden")
      } else {
        card.classList.add("hidden")
      }
    })

    this.tabButtonTargets.forEach(button => {
      if (button.dataset.cardsIdParam === id) {
        button.classList.add("font-medium", "border-blue-500", "text-blue-500")
        button.classList.remove("border-gray-200", "text-gray-400")
      } else {
        button.classList.remove("font-medium", "border-blue-500", "text-blue-500")
        button.classList.add("border-gray-200", "text-gray-400")
      }
    })
  }

  // Zapisuje stan more_options w user_setting.fields via set_field endpoint.
  // Otwarcie zapisuje true, zamknięcie usuwa klucz (value=default).
  savePreference(isOpen) {
    const csrfToken = document.querySelector("meta[name=csrf-token]")
    const key = `more_options.${this.modelKeyValue}`
    const value = isOpen ? "true" : "default"
    const url = `/account/set_field?target=user_setting&key=${encodeURIComponent(key)}&value=${value}`

    fetch(url, {
      method: "POST",
      headers: {
        "X-CSRF-Token": csrfToken && csrfToken.content,
        Accept: "application/json",
      },
    })
  }
}
